import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async getOrgaosExpedidores ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `orgaoExpedidor/getOrgaosExpedidores`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/orgaoExpedidor.js